// extracted by mini-css-extract-plugin
export var filterIncDec = "_3v-0";
export var leftBorder = "_3v-1";
export var rightBorder = "_3v-2";
export var stringInput = "_3v-3";